import { render } from "./home.vue?vue&type=template&id=d6e5f7a6"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=d6e5f7a6&lang=scss"
script.render = render

export default script